import { useQuery } from '../services/NetworkManager';
import { NetworkManager } from '../services';

export type SubscriptionConstraints = {
  MONTHLY?: {
    minimumInvestment: number;
    maximumInvestment: number;
  };
  DAILY?: {
    minimumInvestment: number;
    maximumInvestment: number;
  };
  WEEKLY?: {
    minimumInvestment: number;
    maximumInvestment: number;
  };
};

export function getSubscriptionConstraints() {
  return NetworkManager.Call({
    method: 'get',
    path: NetworkManager.PATH.getSipMinMaxAmount,
  });
}

export default function useSubscriptionConstraints() {
  const { data, isLoading, error } = useQuery(['subscriptionConstraints'], getSubscriptionConstraints);
  return {
    data: data as SubscriptionConstraints | undefined,
    isLoading,
    error,
  };
}
